import { Component, OnInit, Input, ViewChild, AfterViewInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder, UntypedFormArray, AbstractControl, FormGroup } from '@angular/forms';
import { SelectItem, MenuItem, ConfirmationService } from 'primeng/api';
import { Pays } from 'src/app/shared/models/iContact/global/pays';
import { Rue } from 'src/app/shared/models/iContact/global/rue';
import { PostContact } from 'src/app/shared/models/iContact/post/post-contact';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import * as _ from 'underscore';
import { ValidatorsComponent } from 'src/app/validators/validators.component';
import { ToastrService } from 'ngx-toastr';
import { catchError, forkJoin, of, Subject } from 'rxjs';
import * as async from 'async';
import { ContactsLienMembres, LinkedMembersInfos } from 'src/app/shared/models/iContact/global/contacts-lien-membres';
import { NgxSpinnerService } from 'ngx-spinner';
import * as countries from 'src/assets/country/phone.json';
import { Dropdown } from 'primeng/dropdown';
import * as moment from 'moment';
import { DataService } from 'src/app/shared/services/data.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DialogService } from 'primeng/dynamicdialog';
import { LanguagesService } from 'src/app/shared/services/languages.service';
import {
  GroupsGlobalDto,
  ContactTypeDto,
  DropdownContactTitleDTO,
  DropdownContactTypeDTO,
  DropdownLanguage,
  DropdownLegalForm,
  LowInformationsDTO,
  ManagementPostalCodesDTO,
} from 'src/app/shared/interfaces';
import { HttpErrorResponse } from '@angular/common/http';
import { LegalFormsService } from 'src/app/shared/services/legal-forms.service';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { CountriesService } from 'src/app/shared/services/countries.service';
import { CountryDto } from 'src/app/shared/interfaces/countries';
import { BusinessFieldsService } from 'src/app/shared/services/business-fields.service';
import { MaritalStatutesService } from 'src/app/shared/services/marital-statutes.service';
import { GendersService } from 'src/app/shared/services/genders.service';
import { NationalitiesService } from 'src/app/shared/services/nationalities.service';
import { AddressesService } from 'src/app/shared/services/addresses.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { ContactsGlobalService } from 'src/app/shared/services/contacts-global.service';
import { MeService } from 'src/app/shared/services/me.service';
import { PostalCodeByCountryDTO } from 'src/app/shared/interfaces/contacts/dtos/postal-code-by-country-dto.interface';
import { PostalCodeByCountry } from 'src/app/shared/models/iContact/global/postal-code-by-country';
import { ManagementStreetsParams, StreetsByCountry } from 'src/app/shared/models/iContact/global/streets-by-country';
import { StreetByCountryIAddressDTO } from 'src/app/shared/interfaces/addresses/dtos/street-by-country-dto.interface';
import { PostalCodesStreetsParams } from 'src/app/shared/interfaces/contacts/params/postal-codes-streets-params.interface';
import { PostalCodesStreetsDTO } from 'src/app/shared/interfaces/contacts/dtos/postal-codes-streets-dto.interface';
import { ConfigDto } from 'src/app/shared/interfaces/config';
import { AssetsCalendarFr } from 'src/app/shared/models/calendar-fr';
import { ActivatedRoute, Router } from '@angular/router';
import { ManagementStreetsDTO } from 'src/app/shared/interfaces/addresses/dtos/streets-dto.interface';
import { GroupsService } from 'src/app/shared/services/groups.service';
import { IButton } from '@devinforius/i-essentials';
import { AddressAsAList, AddressForFormArray } from 'src/app/shared/models';
import { PostPostalCodeParams } from 'src/app/shared/models/postal-codes/post-postal-code.';
import { ContactTypeParams } from 'src/app/shared/models/iContact/contact/contact-type';
@Component({
  selector: 'app-contact-edition',
  templateUrl: './contact-edition.component.html',
  styleUrls: ['./contact-edition.component.scss'],
  providers: [DialogService],
})
export class ContactEditionComponent implements OnInit, AfterViewInit {
  @Input() public contact;
  @Input() public isNew: boolean;

  public editEnabledGuard = false;
  public globalSubmitESubject: Subject<void> = new Subject<void>();

  public text: string;
  public groupList: SelectItem[];
  public contactForm: UntypedFormGroup;
  public buttons: IButton[] = [
    {
      text: 'Retour',
      styleClass: 'blue',
      disabled: false,
      click: () => {
        this.return();
      },
    },
    {
      text: 'Enregistrer',
      styleClass: 'green',
      id: 'btnSaveModification',
      disabled: false,
      click: () => {
        this.onSubmit();
      },
    },
  ];
  public buttonsIsFromModal: IButton[] = [
    {
      text: 'Retour',
      styleClass: 'blue',
      disabled: false,
      click: () => {
        this.ref.close();
      },
    },
    {
      text: 'Enregistrer',
      styleClass: 'green',
      id: 'btnSaveModification',
      click: () => {
        this.onSubmit();
      },
    },
  ];

  public showCreateCP = false;
  public showCreateStreet = false;
  public showCreateContactType = false;

  public formCP = new FormGroup({
    codePostal: new UntypedFormControl(null, Validators.required),
    localite: new UntypedFormControl(null),
    langueID: new UntypedFormControl(null),
    paysID: new UntypedFormControl(null),
  });
  public formStreet = new FormGroup({
    codePostal: new UntypedFormControl(null, Validators.required),
    codeRue: new UntypedFormControl(null),
    codeLangue: new UntypedFormControl('FR'),
    rue: new UntypedFormControl(null),
  });
  public formContactType = new FormGroup({
    typeContact: new UntypedFormControl(null, Validators.required),
    ordreTri: new UntypedFormControl(null),
    carnetContactID: new UntypedFormControl(null),
    nePasInclureArbreDestinataires: new UntypedFormControl(false),
    nePasRemplirLaListe: new UntypedFormControl(false),
    sanctionTypeVictime: new UntypedFormControl(null),
    categorie: new UntypedFormControl(false),
    categorieParent: new UntypedFormControl(0),
    verrouille: new UntypedFormControl(null),
    // creationGereeParGroupeID: new FormControl(null),
    // modificationGereeParGroupeId: new FormControl(null),
    // suppressionGereeParGroupeId: new FormControl(null),
    // visualisationGereeParGroupeID: new FormControl(null),
  });
  public countries = [];
  public typesLV = [];
  public groups = [];
  public contactsLinked = [];
  public contactsInit = [];
  public actualIndexOfAddressToBeModified: number;
  public typeOfAddressToBeModified: 'impression' | 'structure';
  public actualIndexOfStreetToBeModified: number;
  public typeOfStreetToBeModified: 'impression' | 'structure';

  public countriesList: Pays[];
  public postalCodesList: PostalCodeByCountry[] = [];
  public filteredPostalCodes: PostalCodeByCountry[] = [];
  public typeContacts: DropdownContactTypeDTO[] = [];
  public streetsList: StreetsByCountry[] = [];
  public filteredStreets: Rue[];
  public filteredSectors: {
    label: string;
    value: string;
  }[] = [];
  public contactTitles: DropdownContactTitleDTO[] = [];
  public companiesList: Contact[];
  public langues: DropdownLanguage[] = [];
  public companyMode = false; // default is false
  public isSocietesLiees: boolean; // set to true to activate listSocieteLies input
  public isUpdateMode: boolean;
  public contactId: number;
  public secteursList: { label: string; value: string }[] = [];
  public legalForms: DropdownLegalForm[] = [];
  public etatCivils: { label: string; value: string }[] = [];
  public sexes: { label: string; value: string }[] = [];
  public nationalites: { label: string; value: string }[] = [];

  public fullMode: boolean; // to see the whole form
  public locale4Calendar: AssetsCalendarFr; // locale for calendar
  public yearRange: string;
  public signatureFile: File;
  public arrayItems: {
    id: number;
    structure_RueId: number;
    structure_RueNumero: number;
    structure_LocaliteId: number;
    pays: string;
  }[];

  public sMembers: Array<ContactsLienMembres> = [];
  public liensSocMembres: {
    name: string;
    id: number;
    adresse: string;
    codePostal: string;
    fax: string;
    gsm: string;
    localite: string;
    mail: string;
    relationId: number;
    site: string;
    telephone: string;
    titre: string;
  }[] = [];
  public liensSocSoc: LinkedMembersInfos[] = [];
  public activeIndex = 0;
  public steps: MenuItem[] = [];
  public contactAdresses = [];

  public typesAdresses: { label: string; value: string }[] = [];

  public chgSaved: boolean;
  public connectedContactAccessContacts: boolean;
  public allcontacts: Array<Contact> = [];
  public codeTvaList: SelectItem[] = [
    { label: 'BE', value: 'BE' },
    { label: 'FR', value: 'FR' },
    { label: 'LU', value: 'LU' },
    { label: 'NL', value: 'NL' },
    { label: 'DE', value: 'DE' },
    { label: 'AUTRE', value: 'OTHER' },
  ];

  public tvaMask = 'BE-9999999999';
  public tvaRegex: '';
  public tvaPlaceholder = 'BE-9999999999';
  public tvaFrMode = false;
  public bcePlaceholder = '9999999999';
  public bceMask = '9999999999';
  public bceTooltip = '10 chiffres.';
  public tooltipMember = "Veuillez tout d'abord créer une contact afin de lier à un autre membre";
  public tooltipSociety = "Veuillez tout d'abord créer une contact afin de lier à une autre société";
  public tabMemberDisabled = true;
  public tabSocDisabled = true;
  public isFormSubmit: boolean;
  public typeSocieteList = [
    { label: 'Personne physique', value: false },
    { label: 'Personne morale', value: true },
  ];
  public prefixNumber = '';
  public countriesJSON = countries;
  @ViewChild('Dropdown') stateDropdown: Dropdown;
  @ViewChild('Dropdown2') stateDropdownFrench: Dropdown;
  @ViewChild('DropdownRue') stateDropdownRue: Dropdown;
  public datebirthdefault = new Date();
  public codePays = 'BE';
  public paysContactID: number;
  public contacts: Contact[] = [];
  public saveOK = true;
  public isFromModal = false;
  public clientType = sessionStorage.getItem('clientType');
  public emailCheckPattern: number[] = [];

  emailPattern =
    /^[a-zA-Z0-9. !#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9]{1}[a-zA-Z0-9-]{0,61}[a-zA-Z0-9]{1}[.]{1}[a-zA-Z0-9]{1}[a-zA-Z0-9-]{0,61}[a-zA-Z0-9]{1}$/;
  //Explanation of regex :
  //  [a-zA-Z0-9. !#$%&'*+\/=?^_`{|}~-]    => Accepts all character from 'a' to 'Z' (lowercase + uppercase)+ . + space character + accent letters + .!#$%&'*+\/=?^_`{|}~-
  // + => can have 1 or + or preceding

  // @  +> must have 1x @

  //  [a-zA-Z0-9]{1}  => must start by a to z or A to Z or from 0 to 9 => can only have 1 letter from the []
  // [a-zA-Z0-9-]{0,61}   => Must have same than above or '-' from 0 to 61 times
  // [a-zA-Z0-9]{1} => must have 1 character : a to z or A to Z or from 0 to 9
  // all this 3 together forces to have at least 2 characters with a max of 2+61.
  //so the 1st and last letters should be [a-zA-Z0-9] and in-between you can have 0 or 61 times [a-zA-Z0-9-]

  //[.]{1} must have 1 time a .

  //idem than the 3 together => must finish by min 2 letters [a-zA-Z0-9] and can have 0-61 times [a-zA-Z0-9-]

  emailPattern2 =
    /^[a-zA-Z0-9. !#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9]{1}[a-zA-Z0-9-]{0,61}[a-zA-Z0-9]{1}[.][a-zA-Z0-9]{1}[a-zA-Z0-9-]{0,61}[a-zA-Z0-9]{1}[.]{1}[a-zA-Z0-9]{1}[a-zA-Z0-9-]{0,61}[a-zA-Z0-9]{1}$/;
  //same than before but with 2 points ex xxxx@aaa.bbb.be

  public listOfDisplayedImpressionAdresses: boolean[] = [];

  public selectedZIPByFrenchGouvApi = false;
  private timeoutForGouvCall = null;

  private config: ConfigDto;

  public numberPattern = /^[0-9]*$/;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private translationService: TranslationService,
    public confirmationService: ConfirmationService,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private dataService: DataService,
    public ref: DynamicDialogRef,
    public dataModal: DynamicDialogConfig,
    public langsService: LanguagesService,
    private legalFormsService: LegalFormsService,
    private contactsService: ContactsService,
    private contactsGlobalService: ContactsGlobalService,
    private countriesService: CountriesService,
    private businessFieldsService: BusinessFieldsService,
    private maritalStatutesService: MaritalStatutesService,
    private gendersService: GendersService,
    private nationalitiesService: NationalitiesService,
    private addressesService: AddressesService,
    private configService: ConfigService,
    private meService: MeService,
    private groupsService: GroupsService
  ) {}
  checkEmailPattern(index: number): boolean {
    this.emailCheckPattern = [];
    if (!this.getAdressPrincipal.at(index).value.mail) {
      return true;
    } else {
      if (
        this.emailPattern.test(this.getAdressPrincipal.at(index).value.mail) === false &&
        this.emailPattern2.test(this.getAdressPrincipal.at(index).value.mail) === false
      ) {
        this.emailCheckPattern.push(index);
        return false;
      } else {
        return true;
      }
    }
  }

  ngOnInit(): void {
    this.initForm();
    this.chgSaved = true;
    this.hasChanges(true);
    this.getYearRange();

    forkJoin({
      calendarTranslation: this.translationService.getCalendartranslate(localStorage.getItem('lang')),
      config: this.configService.fetchConfig().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des paramètres globaux de configuration');
          return of(null);
        })
      ),
      businessFields: this.businessFieldsService.fetchBusinessFields().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error("Une erreur est survenue lors de la récupération des secteurs d'activités");
          return of(null);
        })
      ),
      meRightManagement: this.meService.rightManagement().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des droits personnels de gestion');
          return of(null);
        })
      ),
      typeContacts: this.contactsGlobalService.fetchMappedContactTypesToPrimeNGDropdowns().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des types de contacts');
          return of(null);
        })
      ),
      addressTypes: this.contactsService.fetchAddressTypes().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error("Une erreur est survenue lors de la récupération des types d'adresses");
          return of(null);
        })
      ),
      legalForms: this.legalFormsService.fetchMappedLegalFormsToPrimeNGDropdowns().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des formes juridiques');
          return of(null);
        })
      ),
      titles: this.contactsGlobalService.fetchMappedContactTitlesToPrimeNGDropdowns().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des titres');
          return of(null);
        })
      ),
      langages: this.langsService.fetchMappedLanguagesToPrimeNGDropdowns().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des langues');
          return of(null);
        })
      ),
      maritalStatus: this.maritalStatutesService.fetchMaritalStatutes().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des statuts matrimoniaux');
          return of(null);
        })
      ),
      genders: this.gendersService.fetchGenders().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des sexes');
          return of(null);
        })
      ),
      nationalities: this.nationalitiesService.fetchNationalities().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des nationalités');
          return of(null);
        })
      ),
      lowinformationsContactsiCourrier: this.contactsService.getLowInformationsContactsiCourrier({ includeContactParent: true }).pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des contacts de iCourrier');
          return of(null);
        })
      ),
    }).subscribe({
      next: (value) => {
        this.locale4Calendar = value.calendarTranslation;
        this.config = value.config;
        this.formatBusinessFields(value.businessFields);
        this.connectedContactAccessContacts = value.meRightManagement.menu.contacts;
        this.formatTypesContacts(value.typeContacts);
        this.formatAddressTypes(value.addressTypes);
        this.legalForms = value.legalForms;
        this.contactTitles = value.titles;
        this.langues = value.langages;
        this.formatMaritalStatutes(value.maritalStatus);
        this.formatGenders(value.genders);
        this.formatNationalities(value.nationalities);
        this.formatLowInformationsContactsiCourrier(value.lowinformationsContactsiCourrier);

        this.getRouteParams();
      },
    });
    this.contactForm?.valueChanges.subscribe({
      next: (val) => {
        if (val) {
          this.chgSaved = false;
        }
        if (val.typeSociete) {
          if (val.nom !== null && val.langueId !== null) {
            if (this.buttons.length > 0) {
              this.buttons[1].disabled = false;
            }
          } else {
            if (this.buttons.length > 0) {
              this.buttons[1].disabled = true;
            }
          }
        } else {
          if (val.nom !== null && val.langueId !== null && this.emailCheckPattern.length === 0) {
            this.buttons[1].disabled = false;
          } else {
            if (this.buttons[1]) {
              this.buttons[1].disabled = true;
            }
          }
        }
      },
    });
  }

  ngAfterViewInit(): void {
    if (this.stateDropdown) {
      const random = 'nope-' + (Math.random() + 1).toString(36).substring(7);
      this.stateDropdown.renderer.setAttribute(this.stateDropdown.filterViewChild.nativeElement, 'autocomplete', random);
    }
  }

  private formatBusinessFields(businessFields: string[]): void {
    businessFields.forEach((businessField) => {
      this.secteursList.push({ label: businessField, value: businessField });
    });
    this.secteursList = _.sortBy(this.secteursList, 'label');
  }

  private formatTypesContacts(typesContacts: DropdownContactTypeDTO[]): void {
    this.typeContacts = typesContacts;
    this.typeContacts.map((item) => {
      item.label = item.label.charAt(0).toUpperCase() + String(item.label).slice(1).toLowerCase();
    });
  }

  private formatAddressTypes(addressTypes: string[]): void {
    addressTypes.map((item) => {
      this.typesAdresses.push({ label: item, value: item });
    });
  }

  private formatMaritalStatutes(maritalStatus: string[]): void {
    maritalStatus.forEach((maritalStatus) => {
      this.etatCivils.push({ label: maritalStatus, value: maritalStatus });
    });
    this.etatCivils = _.sortBy(this.etatCivils, 'label');
  }

  private formatGenders(genders: string[]): void {
    genders.forEach((gender) => {
      this.sexes.push({ label: gender, value: gender });
    });
    this.sexes = _.sortBy(this.sexes, 'label');
  }

  private formatNationalities(nationalities: string[]): void {
    nationalities.forEach((nationality) => {
      this.nationalites.push({ label: nationality, value: nationality });
    });
    this.nationalites = _.sortBy(this.nationalites, 'label');
  }

  private formatLowInformationsContactsiCourrier(lowInfosContacts: LowInformationsDTO[], setInitDataArray = false): void {
    setInitDataArray ? (this.contactsInit = []) : (this.contacts = []);
    lowInfosContacts.forEach((contact) => {
      const newContact = new Contact(contact);
      if (newContact) {
        newContact.name = (newContact.prenom ? newContact.prenom : '') + ' ' + (newContact.nom ? newContact.nom : '');
        newContact.contactId = newContact.contactID ? newContact.contactID : newContact.contactId;
        setInitDataArray ? this.contactsInit.push(newContact) : this.contacts.push(newContact);
      }
    });
    if (!setInitDataArray) this.contacts = this.contacts.filter((contact) => contact.nePlusUtiliser === false || contact.nePlusUtiliser === null);
    else this.contactsLinked = _.sortBy(this.contactsInit, 'label');
  }

  private setAddressConfig(address: StreetsByCountry, boite: string, number: string): string {
    const params = this.config.groupContacts.impressionAddressOrder;
    let gen_address: string = null;
    const streetName = address.rueNom ? address.rueNom : '';

    if (address) {
      if (params === 'R') {
        gen_address = streetName;
      }
      if (params === 'RB') {
        gen_address = streetName + (boite ? ' bte ' + boite : '');
      }
      if (params === 'RN') {
        gen_address = streetName + ' ' + number;
      }
      if (params === 'BR') {
        gen_address = (boite ? ' bte ' + boite : '') + ' ' + streetName;
      }
      if (params === 'BN') {
        gen_address = (boite ? ' bte ' + boite : '') + ' ' + number;
      }
      if (params === 'NRB') {
        gen_address = number + ' ' + streetName + (boite ? ' bte ' + boite : '');
      }
      if (params === 'NBR') {
        gen_address = number + (boite ? ' bte ' + boite : '') + ' ' + streetName;
      }
      if (params === 'RNB') {
        gen_address = streetName + ' ' + number + (boite ? ' bte ' + boite : '');
      }
      if (params === 'RBN') {
        gen_address = streetName + (boite ? ' bte ' + boite : '') + ' ' + number;
      }
      if (params === 'BNR') {
        gen_address = (boite ? ' bte ' + boite : '') + ' ' + number + ' ' + streetName;
      }
      if (params === 'BRN') {
        gen_address = (boite ? ' bte ' + boite : '') + ' ' + streetName + ' ' + number;
      }
    } else {
      gen_address = '';
    }
    return gen_address;
  }

  initForm(): void {
    this.contactForm = this.formBuilder.group({
      prenom: new UntypedFormControl(null, [Validators.maxLength(200)]),
      nom: new UntypedFormControl(null, [Validators.maxLength(200), Validators.required]),
      titre: new UntypedFormControl(null),
      fonction: new UntypedFormControl(null, [Validators.maxLength(200)]),
      typeContactId: new UntypedFormControl(null),
      nomInterne: new UntypedFormControl(null),
      typeSociete: new UntypedFormControl(null, Validators.required),
      gerantSociete: new UntypedFormControl(null),
      membrePersonnel: new UntypedFormControl(null),
      nePlusUtiliser: new UntypedFormControl(null),
      secteurActivite: new UntypedFormControl(null),
      tvaPrefix: new UntypedFormControl('BE'),
      tva: new UntypedFormControl(null),
      societeFormeJuridiqueId: new UntypedFormControl(null),
      bce: new UntypedFormControl(null),
      listContactsAdresses: new UntypedFormArray([]),
      listSocieteLies: new UntypedFormControl(null),
      siteWeb: new UntypedFormControl(null, [ValidatorsComponent.URL()]),
      langueId: new UntypedFormControl(1, Validators.required),
      numeroCarteNISS: new UntypedFormControl(null),
      dateNaissance: new UntypedFormControl(null),
      naissanceLieu: new UntypedFormControl(null),
      etatCivil: new UntypedFormControl(null),
      sexe: new UntypedFormControl(null),
      nationalite: new UntypedFormControl(),
      commentaires: new UntypedFormControl(null),
      signature1: new UntypedFormControl(null),
      signature2: new UntypedFormControl(null),
      signatureCertifactNom: new UntypedFormControl(null),
      mail: new UntypedFormControl(null),
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.contactForm.controls;
  }

  public getCountries(): Promise<boolean> {
    return new Promise((resolve) => {
      this.countriesService.fetchCountries().subscribe({
        next: (response: CountryDto[]) => {
          this.countriesList = response;

          if (this.isNew) {
            this.add();
          }

          if (this.contact?.tva) {
            const tvaPrefix = this.contact.tva.substring(0, 2);
            this.contact.tvaPrefix = tvaPrefix;
            this.onTvaCodeChg(tvaPrefix, true);
          }
          resolve(true);
        },
        error: (error: HttpErrorResponse) => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des pays');
          console.error(error);
        },
      });
    });
  }

  public selectCountry(data: { originalEvent: PointerEvent; value: number }): void {
    const country = this.countriesList.find((x) => x.id === data.value);
    this.getPostalCodes(country);
  }

  public getPostalCodes(country: CountryDto): Promise<boolean> {
    return new Promise((resolve) => {
      if (country?.id === null) {
        country.id = this.countriesList.find((x) => x.codePays === 'BE').id;
      }

      this.contactsService.getPostalCodesByCountry(country.id).subscribe({
        next: (response: PostalCodeByCountryDTO[]) => {
          this.postalCodesList = response.map((postalCode) => new PostalCodeByCountry(postalCode));
          resolve(true);
        },
        error: (error: HttpErrorResponse) => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des codes postaux');
          console.error(error);
        },
      });
    });
  }

  public selectPostalCode(event, index: number): void {
    if (event.value.id !== -1 && !event.value.isFromAnotherAPI) {
      // si on a choisi un CP normal => de iContact Courrier alors on va récupérer les rues
      this.getStreetsFromiCourrier(event.value);
      this.clearStreet(index);
    } else if (event.value.id === -1) {
      // si on a choisi "Voir plus de code postaux
      const country = this.countriesList.find((x) => x.id === this.getAdressPrincipal.at(index).get('pays').value);
      if (country.codePays !== 'FR') {
        // Alors on va devoir faire un get via iaddress
        this.selectPostalCodeFromiAddress(event.value, country);
      } else {
        // Alors on va devoir faire un get via l api data.gouv française
        this.selectPostalCodeFromFrenchApi(event.value, country);
      }
    } else {
      // Quand on arrive ici c'est qu'on a sélectionné un cp provenant soit de iAddress, soit de l'api française api-adresse.data.gouv.fr
      //pour l'instant on ne fait pas de get avec l'api française car y'a une limite de 50 rues que data.gouv renvoie et donc c'est pas top pour remplir l'array
      this.clearStreet(index);
      if (this.getAdressPrincipal.at(index).get('pays').value !== 'FR') {
        // On arrive ici si on a choisi un CP provenant de iAdresse et donc on va récupérer les rues de ce cp via iAdresse
        // on va devoir envoyer le code langue du contact afin d'afficher les rues dans la bonne langue
        this.getiAddressStreetsByPostalCode(event.value.codePostal);
      }
    }
  }

  private selectPostalCodeFromiAddress(event, country): void {
    this.selectedZIPByFrenchGouvApi = false;
    this.addressesService.fetchLocalities().subscribe({
      next: (res) => {
        this.filteredPostalCodes = [];
        if (res?.length) {
          res.forEach((municipality) => {
            const municipalityName = municipality.nameFr
              ? municipality.nameFr
              : municipality.nameNl
                ? municipality.nameNl
                : municipality.nameDe
                  ? municipality.nameDe
                  : '';
            if (
              municipality.postalcode?.toLowerCase()?.indexOf(event.codePostal) === 0 ||
              municipalityName?.toLowerCase()?.indexOf(event.codePostal) === 0
            ) {
              this.filteredPostalCodes.push({
                id: municipality.id,
                codePostal: municipality.postalcode,
                localite: municipalityName,
                autoCompleteField: municipality.postalcode + ' - ' + municipalityName,
                pays: country,
                isFromAnotherAPI: true,
              });
            }
          });

          if (this.filteredPostalCodes.length === 0) {
            this.stateDropdown.hide();
            this.toastr.info('Aucun résultat pour votre recherche dans iAddress.', 'Information');
          } else {
            this.filteredPostalCodes = this.filteredPostalCodes.sort((a, b) => {
              if (this.numberPattern.test(event.codePostal[0])) {
                return a.codePostal.localeCompare(b.codePostal);
              } else {
                return a.localite.localeCompare(b.localite);
              }
            });
            this.stateDropdown.show();
          }
        } else {
          this.stateDropdown.hide();
          this.toastr.info('Aucun résultat pour votre recherche dans iAddress.', 'Information');
        }
      },
    });
  }

  private selectPostalCodeFromFrenchApi(event, country): void {
    if (typeof event.codePostal === 'number' || !isNaN(event.codePostal)) {
      if (event.codePostal.toString().length !== 5) {
        this.toastr.info('Pour rechercher un code postal composé de chiffres, veuillez entrer le code postal entier (5 chiffres)');
      } else {
        this.selectedZIPByFrenchGouvApi = true;
        this.getFrenchAPIPostCode(event.codePostal, country);
      }
    } else if (typeof event.codePostal === 'string') {
      if (event.codePostal.length < 3) {
        this.toastr.info('Pour rechercher un code postal composé de lettres, veuillez entrer au moins 3 lettres');
      } else {
        this.selectedZIPByFrenchGouvApi = true;
        this.getFrenchAPIPostCode(event.codePostal, country);
      }
    } else {
      this.selectedZIPByFrenchGouvApi = true;
      this.getFrenchAPIPostCode(event.codePostal, country);
    }
  }

  getFrenchAPIPostCode(postCode, country): void {
    // Alors on va devoir faire un get via le site du gouvernement français
    this.contactsService.getFrenchAPIPostCode(postCode).subscribe({
      next: (res) => {
        this.filteredPostalCodes = [];
        if (res?.features.length > 0) {
          res.features.forEach((municipality) => {
            this.filteredPostalCodes.push({
              id: municipality.properties.id,
              codePostal: municipality.properties.postcode,
              localite: municipality.properties.label,
              autoCompleteField: municipality.properties.postcode + ' - ' + municipality.properties.label,
              pays: country,
              isFromAnotherAPI: true,
            });
          });
          if (this.filteredPostalCodes.length === 0) {
            this.stateDropdown.hide();
            this.toastr.info('Aucun résultat pour votre recherche dans iAddress.', 'Information');
          } else {
            this.filteredPostalCodes = this.filteredPostalCodes.sort((a, b) => {
              if (this.numberPattern.test(postCode[0])) {
                return a.codePostal.localeCompare(b.codePostal);
              } else {
                return a.localite.localeCompare(b.localite);
              }
            });
            this.stateDropdown.show();
          }
        } else {
          this.stateDropdown.show();
          this.toastr.warning('Aucun résultats pour votre recherche. Veuillez vérifier le code postal entré');
        }
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error('Une erreur est survenue lors de la récupération des codes postaux (France)');
      },
    });
  }

  getStreetsForChosenZIP(structure_LocaliteId, query: string): Promise<boolean> {
    return new Promise((resolve) => {
      // Si on a un CP de iAdmin
      if (!structure_LocaliteId.isFromAnotherAPI) {
        this.getStreetsFromiCourrier(structure_LocaliteId).then(() => {
          resolve(true);
        });
      } else {
        // Ensuite on détermine si on vient de iAddress ou gouv fr
        // on a pas besoin de resolve car (pour l'instant) cette query n'a besoin de continuer QUE dans le cas de iAdmin
        if (structure_LocaliteId.pays.codePays === 'FR') {
          this.getFrenchAPIStreet(structure_LocaliteId.codePostal, query);
        } else {
          this.getiAddressStreetsByPostalCode(structure_LocaliteId.codePostal).then(() => {
            // Il ne reste plus qu'a filtrer les rues sur celles qui contiennent ce que le user a écrit.
            this.filteredStreets = this.streetsList.filter((street) => street.rueNom.toLowerCase().includes(query.toLowerCase()));
            if (this.filteredStreets.length === 0) {
              this.stateDropdownRue.hide();
              this.toastr.info('Aucun résultat pour votre recherche dans iAddress', 'Information');
            } else {
              this.filteredStreets = this.filteredStreets.sort((a, b) => a.rueNom.localeCompare(b.rueNom));
              this.stateDropdownRue.show();
            }
          });
        }
      }
    });
  }

  selectStreet(event, index): void {
    if (event.value.id === -1) {
      const postalCode = this.getAdressPrincipal.at(index).get('structure_LocaliteId').value;
      const country = this.countriesList.find((x) => x.id === this.getAdressPrincipal.at(index).get('pays').value);
      // Si on est dans "voir plus de rues" alors on doit checker si on est dans le country.codePays Fr ou pas
      // Si c'est "Fr" alors on va faire la recherche via l'API francaise
      if (country.codePays === 'FR') {
        this.getFrenchAPIStreet(postalCode.codePostal, event.value.codeRue);
      } else {
        // Si c'est pas "Fr" alors on va faire la recherche via l'API iAddress
        this.getiAddressStreetsByPostalCode(postalCode.codePostal).then(() => {
          // Il ne reste plus qu'a filtrer les rues sur celles qui contiennent ce que le user a écrit.
          this.filteredStreets = this.streetsList.filter((street) => street.rueNom.toLowerCase().includes(event.value.codeRue.toLowerCase()));
          if (this.filteredStreets.length === 0) {
            this.stateDropdownRue.hide();
            this.toastr.info('Aucun résultat pour votre recherche dans iAddress', 'Information');
          } else {
            this.filteredStreets = this.filteredStreets.sort((a, b) => a.rueNom.localeCompare(b.rueNom));
            this.stateDropdownRue.show();
          }
        });
      }
    }
  }

  private getStreetsFromiCourrier(event): Promise<boolean> {
    return new Promise((resolve) => {
      this.selectedZIPByFrenchGouvApi = false;
      const localiteId = event.id;
      const paysId = event.pays.id;
      this.contactsService.getStreetsByCountry(paysId, localiteId).subscribe({
        next: (response) => {
          this.streetsList = response.map((street) => {
            return new StreetsByCountry(street, 'fromiContact', false);
          });
          this.streetsList = _.sortBy(this.streetsList, 'rueNom');
          resolve(true);
        },
        error: (error) => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des rues');
          console.error(error);
        },
      });
    });
  }

  getFrenchAPIStreet(cityCode: string, streetName: string): void {
    this.contactsService.getFrenchAPIStreet(streetName, +cityCode).subscribe({
      next: (res) => {
        this.filteredStreets = [];
        if (res?.features.length > 0) {
          res.features.forEach((item) => {
            this.filteredStreets.push({
              id: item.properties.id,
              codePostal: item.properties.postcode,
              codeLangue: 'FR',
              codeRue: item.properties.id,
              rueNom: item.properties.name,
              isFromAnotherAPI: true,
            });
          });
          if (this.filteredStreets.length === 0) {
            this.stateDropdownRue.hide();
            this.toastr.info('Aucun résultat pour votre recherche dans l API française.', 'Information');
          } else {
            this.filteredStreets = this.filteredStreets.sort((a, b) => a.rueNom.localeCompare(b.rueNom));
            this.stateDropdownRue.show();
          }
        } else {
          this.stateDropdownRue.hide();
          this.toastr.warning('Aucun résultat pour votre recherche');
        }
      },
    });
  }

  private getiAddressStreetsByPostalCode(postalCode): Promise<boolean> {
    return new Promise((resolve) => {
      this.addressesService.fetchLocalityStreets([postalCode]).subscribe({
        next: (res: StreetByCountryIAddressDTO[]) => {
          const contactLangage = this.langues.find((x) => x.value === this.contactForm.value.langueId)?.codeLangue;
          this.streetsList = res.map((street) => new StreetsByCountry(street, 'fromiAddress', true, contactLangage));
          this.streetsList = _.sortBy(this.streetsList, 'rueNom');
          resolve(true);
        },
        error: (error) => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des rues');
          console.error(error);
        },
      });
    });
  }

  // AutoComplete for postalCode and street
  public search(event, mode: string, index?: number): void {
    const query = event ? event.query : null;

    switch (mode) {
      case 'postalCode':
        if (this.postalCodesList.length === 0) {
          if (this.getAdressPrincipal.at(index).value.pays) {
            const countryToSend = this.countriesList.find((country) => country.id === this.getAdressPrincipal.at(index).value.pays);
            this.getPostalCodes(countryToSend).then(() => {
              this.filteredPostalCodes = this.filter(query, this.postalCodesList, mode);
            });
          } else {
            this.toastr.error('Veuillez choisir un pays avant de rechercher une localité');
          }
        } else {
          this.filteredPostalCodes = this.filter(query, this.postalCodesList, mode);
        }
        break;
      case 'street':
        // Si on a un cp de l'api data.gouv alors on doit "juste" faire l'appel des rues vers data.gouv
        // on va ajouter un petit délais afin de ne pas surcharger l'api.
        if (this.selectedZIPByFrenchGouvApi) {
          clearTimeout(this.timeoutForGouvCall);
          this.timeoutForGouvCall = setTimeout(() => {
            const postalCodeToSend = this.getAdressPrincipal.at(index).value.structure_LocaliteId.codePostal;
            this.getFrenchAPIStreet(postalCodeToSend, query);
          }, 1000);
        } else {
          // par contre si on a un cp de iAdmin ou de iAddress, on doit vérifier si on a une liste de rues, sinon on va faire un appel pour les récupérer.
          // on pourrait ne pas avoir de rues si on entre en édition d'un contact et que l'on modifie direct une rue.
          if (this.streetsList.length === 0) {
            if (this.getAdressPrincipal.at(index).value.structure_LocaliteId.codePostal !== null) {
              this.getStreetsForChosenZIP(this.getAdressPrincipal.at(index).value.structure_LocaliteId, query).then(() => {
                this.filteredStreets = this.filter(query, this.streetsList, mode, index);
              });
            } else {
              this.toastr.error('Veuillez choisir un code postal avant de choisir une rue.');
            }
          } else {
            this.filteredStreets = this.filter(query, this.streetsList, mode, index);
          }
        }
        break;
      case 'sector':
        this.filteredSectors = this.filter(query, this.secteursList, mode);
        break;
    }
  }

  public filter(query, list, mode?: string, index?: number) {
    let filtered = [];
    const tempArray = [];
    switch (mode) {
      case 'postalCode':
        list.forEach((postalCode) => {
          if (postalCode?.localite && postalCode.localite.toLowerCase().indexOf(query.toLowerCase()) === 0) {
            filtered.push(postalCode);
          } else if (postalCode?.localite && postalCode.codePostal.indexOf(query) === 0) {
            filtered.push(postalCode);
          }
        });

        filtered = filtered.sort((a, b) => {
          if (this.numberPattern.test(query[0])) {
            // Si on commence par un nombre => trie par codes postaux
            return a.codePostal.localeCompare(b.codePostal);
          } else {
            // Si on commence par une lettre => trie par localités
            return a.localite.localeCompare(b.localite);
          }
        });

        filtered.push({
          autoCompleteField: 'Voir plus de codes postaux',
          codePostal: query,
          id: -1,
          localite: 'Voir plus de codes postaux',
          isFromAnotherAPI: true,
        });
        break;
      case 'street': {
        list.forEach((street) => {
          if (street.rueNom.toLowerCase().includes(query.toLowerCase())) {
            tempArray.push(street);
          }
        });
        const contactLangage = this.langues.find((x) => x.value === this.contactForm.value.langueId)?.codeLangue;

        filtered = tempArray.filter((x) => (['FR', 'NL', 'DE'].includes(contactLangage) ? x.codeLangue === contactLangage : x.codeLangue === 'FR'));

        filtered = filtered.sort((a, b) => a.rueNom.localeCompare(b.rueNom));

        if (this.getAdressPrincipal.at(index).value.structure_LocaliteId.isFromAnotherAPI === false) {
          filtered.push({
            id: -1,
            codePostal: null,
            codeRue: query,
            codeLangue: null,
            rueNom: 'Voir plus de rues',
            isFromAnotherAPI: true,
          });
        }

        break;
      }
      case 'sector':
        list.map((sector) => {
          if (sector.label.toLowerCase().includes(query.toLowerCase())) {
            filtered.push(sector);
          }
        });
        break;
    }
    return filtered;
  }

  public showMore(): void {
    this.fullMode = !this.fullMode;
  }

  public onSubmit(): void {
    this.isFormSubmit = true;
    if (!this.isUpdateMode) {
      this.contact = new PostContact(this.contact);
    }

    if (!this.paysContactID) {
      this.paysContactID = 1;
    }

    if (this.contactForm.value.titre) {
      this.contact.titre = this.contactForm.value.titre.titre;
    }

    this.checkIfStructuredAddressIsFilled().then(() => {
      this.checkIfStructureAndImpressionAddressesAreSame().then(() => {
        this.spinner.show();
        this.setAddressesAsAList().then((arrayOfAddresses) => {
          const temp_array_adress = arrayOfAddresses;
          this.spinner.show();
          this.contact = this.contactForm.getRawValue();

          if (this.f['tva'].value !== '' && this.f['tva'].value !== null) {
            this.contact['tva'] = this.f['tva'].value.replace(/-/g, '').replace(/\./g, '');
            this.contact['tva'] = this.contact['tva'].toUpperCase();
          }

          this.contact.paysContactID = this.paysContactID;

          if (this.paysContactID !== 1) {
            this.contact.pasDeTVABelge = true;
          } else this.contact.pasDeTVABelge = false;

          this.contact.listContactsAdresses = _.clone(temp_array_adress);

          this.contact.secteurActivite = this.contact.secteurActivite?.value;

          if (!this.isUpdateMode) {
            this.submitNewContact();
          } else {
            this.updateNewContact();
          }
        });
      });
    });
  }

  //to be Put in an utils
  private checkIfStructuredAddressIsFilled(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.contactForm.value.listContactsAdresses.length > 0) {
        const errors: string[] = [];
        async.eachSeries(
          this.contactForm.value.listContactsAdresses,
          (item: AddressForFormArray, cbEachSeries) => {
            if (item.toRemove) {
              //si l'adresse est a supprimer => aucune modif nécessaire
              cbEachSeries(null);
            } else if (item.impression_Adresse && item.structure_RueId === null) {
              this.spinner.hide();
              this.confirmationService.confirm({
                message:
                  "Pour l'adresse " +
                  item.type.toLowerCase() +
                  ', l’adresse impression est remplie mais l’adresse structurée est vide. Souhaitez-vous sauver tout de même?',
                key: 'confirmContact',
                accept: () => {
                  cbEachSeries(null);
                },
                reject: () => {
                  errors.push('refused');
                  cbEachSeries(null);
                },
              });
            } else {
              cbEachSeries(null);
            }
          },
          () => {
            //on va vérifier s'il y a une err car on ne peut pas break d'un async.each/ eachSeries
            errors?.length > 0 ? (this.saveOK = false) : (this.saveOK = true);
            resolve(true);
          }
        );
      } else {
        resolve(true);
      }
    });
  }

  //to be Put in an utils
  private checkIfStructureAndImpressionAddressesAreSame(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.contactForm.getRawValue().listContactsAdresses.length > 0) {
        const errors: string[] = [];
        async.eachSeries(
          this.contactForm.getRawValue().listContactsAdresses,
          (item: AddressForFormArray, cbAsyncEachSeries) => {
            if (item.toRemove) {
              //si l'adresse est a supprimer => aucune modif nécessaire
              cbAsyncEachSeries(null);
            } else if (
              (item.structure_LocaliteId && item.impression_CodePostal && item.structure_LocaliteId.codePostal !== item.impression_CodePostal) ||
              (item.structure_LocaliteId && item.impression_Localite && item.structure_LocaliteId.localite !== item.impression_Localite)
            ) {
              this.spinner.hide();
              this.confirmationService.confirm({
                message:
                  "Pour l'adresse " +
                  item.type.toLowerCase() +
                  ', l’adresse impression est différente de l’adresse structurée. Souhaitez-vous sauver tout de même?',
                key: 'confirmContact',
                accept: () => {
                  cbAsyncEachSeries(null);
                },
                reject: () => {
                  errors.push('refused');
                  cbAsyncEachSeries(null);
                },
              });
            } else {
              cbAsyncEachSeries(null);
            }
          },
          () => {
            //on va vérifier s'il y a une err car on ne peut pas break d'un async.each/ eachSeries
            errors?.length > 0 ? (this.saveOK = false) : (this.saveOK = true);
            resolve(true);
          }
        );
      } else {
        resolve(true);
      }
    });
  }

  //to be Put in an utils
  private setAddressesAsAList(): Promise<AddressAsAList[]> {
    return new Promise((resolve) => {
      const temp_array_adress: AddressAsAList[] = [];
      if (this.contactForm.getRawValue().listContactsAdresses.length > 0) {
        async.eachOfSeries(
          this.contactForm.getRawValue().listContactsAdresses,
          (item: AddressForFormArray, index, cbAsyncEachSeries) => {
            if (item.toRemove) {
              temp_array_adress.push(this.setNewAddress(item, index));
              cbAsyncEachSeries(null);
            } else {
              if (item.structure_LocaliteId?.id === -1 || !item.structure_LocaliteId?.id) {
                //! === -1 car l'utilisateur pourrait très bien garder le "voir plus" en l'ayant oublié => s'il a cliqué sur "voir plus" sans choisir de cp /  rue; que cela ne s'envoie pas au backend.
                item.structure_LocaliteId = null;
                item.structure_RueId = null;
              }
              if (item.structure_RueId?.id === -1 || !item.structure_RueId?.id) {
                item.structure_RueId = null;
              }

              // Si on a des adresses on va devoir vérifier si on a pas une localité ou une rue qui provient d'une autre api que celle de iAdmin.
              if (item.structure_LocaliteId?.isFromAnotherAPI || item.structure_RueId?.isFromAnotherAPI) {
                // Si on a au moins la rue ou la localite en isFromAnotherAPI alors on doit d'abord créer l'adresse dans iContact avant de pouvoir aller plus loin
                const zipAndStreetParams: PostalCodesStreetsParams = {
                  codePostal: {
                    codePostal: item.structure_LocaliteId.codePostal,
                    localite: item.structure_LocaliteId.localite,
                    langueID: this.langues.find((x) => x.value === this.contactForm.value.langueId)?.value, // langue du contact
                    paysID: +item.pays,
                    externalApiSourceId: item.structure_LocaliteId.id.toString(),
                  },
                  rue: {
                    codePostal: item.structure_LocaliteId.codePostal,
                    codeRue: item.structure_RueId.codeRue ? item.structure_RueId.codeRue : '',
                    codeLangue: item.structure_RueId.codeLangue ? item.structure_RueId.codeLangue : '',
                    rue: item.structure_RueId.rueNom ? item.structure_RueId.rueNom : '',
                    externalApiSourceId: item.structure_RueId.id ? item.structure_RueId.id.toString() : '',
                  },
                };
                // Si le cp n'est pas d'une autre api, ca ne sert a rien d'ajouter son id externe
                if (!item.structure_LocaliteId?.isFromAnotherAPI) {
                  delete zipAndStreetParams.codePostal.externalApiSourceId;
                }

                this.contactsService.postCodesPostauxRues(zipAndStreetParams).subscribe({
                  next: (res: PostalCodesStreetsDTO) => {
                    temp_array_adress.push({
                      type: item.type && item.type !== null ? item.type : 'PRINCIPALE',
                      description: item.type !== 'PRINCIPALE' ? item.type : '',
                      contactID: this.contactId,
                      adresse: {
                        toRemove: item.toRemove, // Il est forcément false mais on doit l'ajouter
                        structure_LocaliteId: res.codePostal.id ? +res.codePostal.id : null,
                        structure_RueId: res.rue.id ? +res.rue.id : null,
                        structure_RueNumero: item.structure_RueNumero ? item.structure_RueNumero : '',
                        structure_RueBoite: item.structure_RueBoite ? item.structure_RueBoite : '',
                        langueId: this.langues.find((x) => x.value === this.contactForm.value.langueId)?.value,
                        impression_Adresse: item.impression_Adresse
                          ? item.impression_Adresse
                          : item.structure_RueId !== null
                            ? item.structure_RueId.rueNom +
                              (item.structure_RueNumero ? ', ' + item.structure_RueNumero + ', ' : '') +
                              (item.structure_RueBoite ? ' bte ' + item.structure_RueBoite : '')
                            : '',
                        impression_CodePostal: item.impression_CodePostal
                          ? item.impression_CodePostal
                          : res.codePostal.codePostal
                            ? res.codePostal.codePostal
                            : '',
                        impression_Localite: item.impression_Localite
                          ? item.impression_Localite
                          : res.codePostal.localite
                            ? res.codePostal.localite
                            : '',
                        impression_Pays: item.impression_Pays
                          ? item.impression_Pays
                          : this.countriesList.find((x) => x.id === item.pays)?.description,
                        telephone: item.telephone ? item.telephone : '',
                        fax: item.fax ? item.fax : '',
                        gsm: item.gsm ? item.gsm : '',
                        site: item.site ? item.site : '',
                        mail: index === 0 ? this.contactForm.value.mail : item.mail && item.mail !== null ? item.mail : '',
                        id: item.id ? item.id : null,
                      },
                    });
                    cbAsyncEachSeries();
                  },
                });
              } else {
                temp_array_adress.push(this.setNewAddress(item, index));
                cbAsyncEachSeries();
              }
            }
          },
          () => {
            resolve(temp_array_adress);
          }
        );
      } else {
        temp_array_adress.push(this.setNewEmptyAddress());
        resolve(temp_array_adress);
      }
    });
  }

  //to be Put in an utils
  private setNewEmptyAddress(): AddressAsAList {
    return {
      type: 'PRINCIPALE',
      description: 'PRINCIPALE',
      contactID: this.contactId,
      adresse: {
        toRemove: false,
        structure_LocaliteId: null,
        structure_RueId: null,
        structure_RueNumero: '',
        structure_RueBoite: '',
        langueId: this.langues.find((x) => x.value === this.contactForm.value.langueId)?.value,
        impression_Adresse: '',
        impression_CodePostal: '',
        impression_Localite: '',
        impression_Pays: '',
        telephone: '',
        fax: '',
        gsm: '',
        site: '',
        mail: this.contactForm.value.mail ? this.contactForm.value.mail : '',
        id: null,
      },
    };
  }

  //to be Put in an utils
  private setNewAddress(item, index): AddressAsAList {
    return {
      type: item.type && item.type !== null ? item.type : 'PRINCIPALE',
      description: item.type !== 'PRINCIPALE' ? item.type : '',
      contactID: this.contactId,
      adresse: {
        toRemove: item.toRemove, //il FAUT le reprendre sinon on ne supprime jamais plus bas :)
        structure_LocaliteId: item.structure_LocaliteId?.id ? +item.structure_LocaliteId.id : null,
        structure_RueId: item.structure_RueId?.id ? +item.structure_RueId.id : null,
        structure_RueNumero: item.structure_RueNumero ? item.structure_RueNumero : '',
        structure_RueBoite: item.structure_RueBoite ? item.structure_RueBoite : '',
        langueId: this.langues.find((x) => x.value === this.contactForm.value.langueId)?.value,
        impression_Adresse: item.impression_Adresse
          ? item.impression_Adresse
          : item.structure_RueId !== null
            ? item.structure_RueId.rueNom +
              (item.structure_RueNumero ? ', ' + item.structure_RueNumero + ', ' : '') +
              (item.structure_RueBoite ? ' bte ' + item.structure_RueBoite : '')
            : '',
        impression_CodePostal: item.impression_CodePostal
          ? item.impression_CodePostal
          : item.structure_LocaliteId
            ? item.structure_LocaliteId.codePostal
            : '',
        impression_Localite: item.impression_Localite
          ? item.impression_Localite
          : item.structure_LocaliteId
            ? item.structure_LocaliteId.localite
            : '',
        impression_Pays: item.impression_Pays ? item.impression_Pays : this.countriesList.find((x) => x.id === item.pays)?.description,
        telephone: item.telephone ? item.telephone : '',
        fax: item.fax ? item.fax : '',
        gsm: item.gsm ? item.gsm : '',
        site: item.site ? item.site : '',
        mail: index === 0 ? this.contactForm.value.mail : item.mail && item.mail !== null ? item.mail : '',
        id: item.id ? item.id : null,
      },
    };
  }

  private submitNewContact(): void {
    this.spinner.show();
    if (this.contact.typeSociete === null || this.contact.typeSociete === false) {
      this.submitNewPhysicalContact();
    } else {
      this.submitNewSocietyContact();
    }
  }

  private submitNewPhysicalContact(): void {
    // C'est un utilisateur lambda qu'on check
    if (!this.saveOK) return;
    if (this.contact.nom === null) {
      this.toastr.error('Le nom est requis');
      this.spinner.hide();
      return;
    }
    if (this.contact.langueId === null) {
      this.toastr.error('La langue est requise');
      this.spinner.hide();
      return;
    }
    if (this.emailCheckPattern.length > 0) {
      this.toastr.error('Une ou plusieurs adresse(s) email(s) est/sont invalide(s) (exemple@me.com / exemple@me.test.com))');
      this.spinner.hide();
      return;
    }
    if (!this.contactForm.valid) {
      this.toastr.error("Le formulaire n'est pas valide");
      this.spinner.hide();
      return;
    }

    this.contactsService.postContact('iCourrier', this.contact).subscribe({
      next: () => {
        this.spinner.hide();
        this.toastr.success('Merci', 'Votre contact a bien été créé!');
        this.chgSaved = true;

        this.dataService.setReloadContact(true);
        this.router.navigateByUrl('/private/ic/contacts/details/' + this.contact.id);
      },
      error: (error) => {
        this.spinner.hide();
        console.error('Error : ', error);
        this.toastr.error("Une erreur est survenue lors de l'envoi du formulaire");
      },
    });
  }

  private submitNewSocietyContact(): void {
    // C'est une société qu'on check
    if (this.contact.nom === null) {
      this.toastr.error('Le nom est requis');
      this.spinner.hide();
      return;
    }
    if (this.contact.langueId === null) {
      this.toastr.error('La langue est requise');
      this.spinner.hide();
      return;
    }
    if (this.emailCheckPattern.length > 0) {
      this.toastr.error('Une ou plusieurs adresse(s) email(s) est/sont invalide(s) (exemple@me.com))');
      this.spinner.hide();
      return;
    }
    this.contactsService.postContact('iCourrier', this.contact).subscribe({
      next: () => {
        this.spinner.hide();
        this.toastr.success('Merci', 'Votre contact a bien été créé!');
        this.chgSaved = true;
        this.dataService.setReloadContact(true);
        this.router.navigateByUrl('/private/ic/contacts/details/' + this.contact.id);
      },
      error: (error) => {
        console.error('Error : ', error);
        this.spinner.hide();
        this.toastr.error("Une erreur est survenue lors de l'envoi du formulaire");
      },
    });
  }

  private updateNewContact(): void {
    this.spinner.show();

    // ON CHECK TOUT
    let typeArray = [];
    typeArray = this.contact.listContactsAdresses.map(function (item) {
      return item.type;
    });

    const isDuplicate = typeArray.some(function (item, idx) {
      return typeArray.indexOf(item) != idx && item !== 'AUTRE';
    });

    if (isDuplicate) {
      this.toastr.error("Vous ne pouvez pas avoir deux types d'adresses équivalentes, sauf pour les types 'Autre'");
      this.spinner.hide();
      return;
    }

    if (this.contact.typeSociete === null || this.contact.typeSociete === false) {
      this.updatePhysicalContact();
    } else {
      this.updateSocietyContact();
    }
  }

  private updatePhysicalContact(): void {
    // C'est un utilisateur lambda qu'on check
    if (this.contact.nom === null || this.contact.langueId === null || this.emailCheckPattern.length > 0) {
      if (this.contact.nom === null) {
        this.toastr.error('Le nom est requis');
      }
      if (this.contact.langueId === null) {
        this.toastr.error('La langue est requise');
      }
      if (this.emailCheckPattern.length > 0) {
        this.toastr.error('Une ou plusieurs adresse(s) email(s) est/sont invalide(s) (exemple@me.com))');
      }
      this.spinner.hide();
      return;
    }

    const has_main_adress = this.contact.listContactsAdresses.filter((x) => x.type === 'PRINCIPALE');
    if (has_main_adress?.length === 0) {
      this.toastr.error('Vous devez avoir au moins une adresse principale!');
      return;
    }

    delete this.contact.typeContact;
    delete this.contact['langue'];
    delete this.contact['adressePrincipale'];

    async.eachSeries(
      this.contact.listContactsAdresses,
      (item_form: AddressAsAList, cb) => {
        if (item_form.adresse['id'] > 0 && !item_form.adresse.toRemove) {
          const contactId = item_form['contactID'];
          const id = item_form.adresse['id'];

          delete item_form.contactID;
          delete item_form.adresse.toRemove;

          if (this.saveOK) {
            this.contactsService.putContactAddresses(contactId, id, item_form).subscribe({
              next: () => {
                this.toastr.success('Une adresse a été mise à jour pour ce contact');
                cb();
              },
            });
          }
        } else if (item_form.adresse['id'] > 0 && item_form.adresse.toRemove) {
          const contactId = item_form['contactID'];
          const id = item_form.adresse['id'];

          if (this.saveOK) {
            this.contactsService.deleteContactAddresses(contactId, id).subscribe({
              next: () => {
                this.toastr.success('Une adresse a été supprimé pour ce contact');
                cb();
              },
            });
          }
        }
      },
      () => {
        delete this.contact.listContactsAdresses;

        if (this.saveOK && this.emailCheckPattern.length === 0) {
          this.contactsService.putContact('iCourrier', this.contactId, this.contact).subscribe({
            next: (response) => {
              this.spinner.hide();
              this.toastr.success('Merci', 'Votre contact a été mis a jour!');
              this.chgSaved = true;
              if (this.isFromModal) {
                this.ref.close(response);
              } else {
                this.dataService.setReloadContact(true);
                this.router.navigateByUrl('/private/ic/contacts/details/' + this.contactId);
              }
            },
            error: (error) => {
              console.error('Error : ', error);
              this.spinner.hide();
              this.toastr.error("Une erreur s'est produite votre contact n'a pas été mis à jour");
            },
          });
        }
      }
    );
  }

  private updateSocietyContact(): void {
    // C'est une société qu'on check
    if (this.contact.nom === null || this.contact.langueId === null || this.emailCheckPattern.length > 0) {
      if (this.contact.nom === null) {
        this.toastr.error('Le nom est requis');
      }
      if (this.contact.langueId === null) {
        this.toastr.error('La langue est requise');
      }
      if (this.emailCheckPattern.length > 0) {
        this.toastr.error('Une ou plusieurs adresse(s) email(s) est/sont invalide(s) (exemple@me.com))');
      }
      this.spinner.hide();
      return;
    }

    const has_main_adress = this.contact.listContactsAdresses.filter((x) => x.type === 'PRINCIPALE');
    if (has_main_adress?.length === 0) {
      this.toastr.error('Vous devez avoir au moins une adresse principale!');
      this.spinner.hide();
      return;
    }

    delete this.contact.typeContact;
    delete this.contact['langue'];
    delete this.contact['adressePrincipale'];
    this.contact.prenom = '';

    async.eachSeries(
      this.contact.listContactsAdresses,
      (item_form: AddressAsAList, cb) => {
        if (item_form.adresse['id'] > 0 && !item_form.adresse.toRemove) {
          const contactId = item_form['contactID'];
          const id = item_form.adresse['id'];

          delete item_form.contactID;
          delete item_form.adresse.toRemove;

          if (this.saveOK) {
            this.contactsService.putContactAddresses(contactId, id, item_form).subscribe({
              next: () => {
                this.toastr.success('une adresse a été mise à jour pour ce contact');
                cb();
              },
            });
          }
        } else if (item_form.adresse['id'] > 0 && item_form.adresse.toRemove) {
          const contactId = item_form['contactID'];
          const id = item_form.adresse['id'];

          if (this.saveOK) {
            this.contactsService.deleteContactAddresses(contactId, id).subscribe({
              next: () => {
                this.toastr.success('une adresse a été supprimé pour ce contact');
                cb();
              },
            });
          }
        }
      },
      () => {
        if (this.saveOK) {
          this.contactsService.putContact('iCourrier', this.contactId, this.contact).subscribe({
            next: (response) => {
              this.toastr.success('Merci', 'Votre contact a été mis a jour!');
              this.chgSaved = true;
              this.spinner.hide();
              if (this.isFromModal) {
                this.ref.close(response);
              } else {
                this.router.navigateByUrl('/private/ic/contacts/details/' + this.contactId);
              }
            },
            error: (error) => {
              console.error('Error : ', error);
              this.spinner.hide();
            },
          });
        }
      }
    );
  }

  get getAdressPrincipal(): UntypedFormArray {
    return this.contactForm.get('listContactsAdresses') as UntypedFormArray;
  }
  add(): void {
    this.getAdressPrincipal.push(
      this.formBuilder.group({
        type: new UntypedFormControl(this.getAdressPrincipal.length ? 'SECONDAIRE' : 'PRINCIPALE', Validators.required),
        structure_RueId: new UntypedFormControl(null),
        structure_RueNumero: new UntypedFormControl(null),
        structure_RueBoite: new UntypedFormControl(null),
        structure_LocaliteId: new UntypedFormControl(null),
        impression_Pays: new UntypedFormControl(null),
        impression_CodePostal: new UntypedFormControl(null),
        impression_Localite: new UntypedFormControl(null),
        impression_Adresse: new UntypedFormControl(null),
        pays: new UntypedFormControl(
          this.clientType !== 'JVS' ? this.countriesList.find((x) => x.codePays === 'BE').id : this.countriesList.find((x) => x.codePays === 'FR').id
        ),
        gsm: new UntypedFormControl(null),
        mail: new UntypedFormControl(null, [Validators.email]),
        telephone: new UntypedFormControl(null),
        fax: new UntypedFormControl(null),
        site: new UntypedFormControl(null),
        toRemove: new UntypedFormControl(false),
      })
    );
    this.listOfDisplayedImpressionAdresses.push(false);
  }

  remove(index): void {
    this.confirmationService.confirm({
      message: 'Voulez-vous vraiment supprimer cette adresse ?',
      key: 'confirmContact',
      accept: () => {
        const toFind = this.getAdressPrincipal.at(index);

        toFind.value.toRemove = true;
        this.getAdressPrincipal.at(index).patchValue({
          toRemove: true,
        });

        this.listOfDisplayedImpressionAdresses[index] = false;

        this.toastr.success('Adresse supprimée temporairement, vous devez cliquer sur enregistrer pour valider vos changements!');
        if (this.getAdressPrincipal.length === 0) {
          const data = {
            type: 'PRINCIPALE',
            structure_RueId: '',
            structure_RueNumero: '',
            structure_RueBoite: '',
            structure_LocaliteId: '',
            pays: '',
            gsm: '',
            mail: '',
            telephone: '',
            fax: '',
            site: '',
          };
          this.contactForm.value.listContactsAdresses = data;
        }
      },
    });
  }

  public switchToCompany(): void {
    this.companyMode = !this.companyMode;
  }

  public getYearRange(): void {
    this.yearRange = `${new Date().getFullYear() - 100}:${new Date().getFullYear()}`;
  }

  deleteContact(): void {
    this.confirmationService.confirm({
      message: 'Voulez-vous vraiment supprimer ce contact?',
      accept: () => {
        this.contactsService.deleteContact('iCourrier', this.contactId).subscribe({
          next: () => {
            this.toastr.success('Merci', "Ce contact n'apparaitra plus dans votre liste de contact");
            this.dataService.setReloadContact(true);
            this.router.navigateByUrl('/private/ic/contacts/');
          },
          error: (error) => {
            console.error('Error : ', error);
          },
        });
      },
    });
  }

  public receiveSocCount(count: number): void {
    this.liensSocSoc.length = count;
  }

  public getRouteParams(): void {
    const routeParams = this.route.snapshot.params;
    if (this.dataModal && this.dataModal.data) {
      this.isNew = false;
      const id = this.dataModal.data.contactID ? this.dataModal.data.contactID : null;
      this.getContact(id);
      this.isUpdateMode = true;
      this.tooltipMember = '';
      this.tooltipSociety = '';
      this.tabMemberDisabled = false;
      this.tabSocDisabled = false;
      this.isFromModal = true;
    } else {
      if (routeParams?.id && routeParams.id !== 'new') {
        this.isNew = false;
        const id = +routeParams.id;
        this.getContact(id);
        this.isUpdateMode = true;
        this.tooltipMember = '';
        this.tooltipSociety = '';
        this.tabMemberDisabled = false;
        this.tabSocDisabled = false;
      } else {
        this.text = 'Nouveau contact';
        this.contact = new PostContact();
        this.isNew = true;
        this.isUpdateMode = false;
        this.contactForm.reset();
        this.tooltipMember = "Veuillez tout d'abord créer une contact afin de le lier à un autre membre";
        this.tooltipSociety = "Veuillez tout d'abord créer une contact afin de le lier à une autre société";
        this.tabMemberDisabled = true;
        this.tabSocDisabled = true;
      }
    }
  }

  getContact(id: number): void {
    this.contactsService.fetchContact(id, 'iCourrier').subscribe({
      next: (response) => {
        this.contact = response;
        this.contact.dateNaissance = this.contact.dateNaissance ? moment(this.contact.dateNaissance).format('DD/MM/YYYY') : null;
        this.contactId = this.contact.id;
        this.companyMode = this.contact.typeSociete;
        this.contact.secteurActivite = this.secteursList.find((x) => x.value === this.contact.secteurActivite);

        forkJoin({
          membersLinked: this.contactsGlobalService.getSocietesV2(this.contact.id).pipe(
            catchError(() => {
              this.spinner.hide();
              this.toastr.error('Une erreur est survenue lors de la récupération des societes');
              return of(null);
            })
          ),
          countries: this.getCountries(),
          contactAddresses: this.contactsService.fetchContactAddresses(this.contactId).pipe(
            catchError(() => {
              this.spinner.hide();
              this.toastr.error('Une erreur est survenue lors de la récupération des adresses');
              return of(null);
            })
          ),
        }).subscribe({
          next: (res) => {
            if (res.membersLinked.typeSociete === false) {
              this.liensSocSoc = res.membersLinked.liensMembres.map((item) => new LinkedMembersInfos(item));
            } else {
              res.membersLinked.liensMembres.map((item) => {
                this.liensSocMembres.push({
                  name: (item.lienContact.nom ? item.lienContact.nom + ' ' : '') + (item.lienContact.prenom ? item.lienContact.prenom : ''),
                  id: item.lienContact.id,
                  adresse: item.lienInfo.adresse,
                  codePostal: item.lienInfo.codePostal,
                  fax: item.lienInfo.fax,
                  gsm: item.lienInfo.gsm,
                  localite: item.lienInfo.localite,
                  mail: item.lienInfo.mail,
                  relationId: item.lienInfo.relationId,
                  site: item.lienInfo.site,
                  telephone: item.lienInfo.telephone,
                  titre: item.lienInfo.titre,
                });
              });
            }

            for (let i = 0; i < res.contactAddresses.length; i++) {
              this.listOfDisplayedImpressionAdresses[i] = false;
            }

            res.contactAddresses.forEach((item) => {
              const pays = item.adresse.structure_Localite?.pays
                ? item.adresse.structure_Localite.pays
                : this.countriesList.find((x) => x.codePays === 'BE');

              const street = {
                codeLangue: item.adresse.structure_Rue?.codeLangue ? item.adresse.structure_Rue?.codeLangue : null,
                codePostal: item.adresse.structure_Rue?.codePostal ? item.adresse.structure_Rue?.codePostal : null,
                codeRue: item.adresse.structure_Rue?.codeRue ? item.adresse.structure_Rue?.codeRue : null,
                id: item.adresse.structure_Rue?.id ? item.adresse.structure_Rue?.id : null,
                rueNom: item.adresse.structure_Rue?.rueNom ? item.adresse.structure_Rue?.rueNom : null,
                isFromAnotherAPI: false,
              };

              const localite = {
                id: item.adresse.structure_Localite ? item.adresse.structure_Localite.id : null,
                codePostal: item.adresse.structure_Localite ? item.adresse.structure_Localite.codePostal : null,
                localite: item.adresse.structure_Localite ? item.adresse.structure_Localite.localite : null,
                autoCompleteField: item.adresse.structure_Localite
                  ? item.adresse.structure_Localite.codePostal + ': ' + item.adresse.structure_Localite.localite
                  : null,
                pays: item.adresse.structure_Localite ? item.adresse.structure_Localite.pays : null,
                isFromAnotherAPI: false,
              };

              if (item.adresse.impression_Adresse === 'null') {
                item.adresse.impression_Adresse = null;
              }

              this.contactAdresses.push({
                contactID: this.contactId,
                type: item.type,
                id: item.id,
                structure_RueId: street?.id ? street : null,
                structure_RueNumero: item.adresse.structure_RueNumero,
                structure_RueBoite: item.adresse.structure_RueBoite,
                structure_LocaliteId: localite?.id ? localite : null,
                impression_Pays: item.adresse.impression_Pays,
                impression_CodePostal: item.adresse.impression_codePostal,
                impression_Adresse: item.adresse.impression_Adresse,
                impression_Localite: item.adresse.impression_Localite,
                gsm: item.adresse.gsm,
                mail: item.adresse.mail,
                telephone: item.adresse.telephone,
                fax: item.adresse.fax,
                site: item.adresse.site,
                pays: pays.id,
                toRemove: false,
              });
            });
            this.contact.listContactsAdresses = this.contactAdresses;
            const addressArray = [];
            this.contact.listContactsAdresses = this.contact.listContactsAdresses.map((x) => {
              if (x.type === 'PRINCIPALE') {
                x.priority = 1;
                addressArray.push(x);
              } else if (x.type === 'SECONDAIRE') {
                x.priority = 2;
                addressArray.push(x);
              } else if (x.type === 'PRIVE') {
                x.priority = 3;
                addressArray.push(x);
              } else {
                x.priority = 4;
                addressArray.push(x);
              }
              return x;
            });
            addressArray.map((add) => {
              this.getAdressPrincipal.push(this.formBuilder.group(add));
            });
            this.contact.listContactsAdresses = _.sortBy(this.contact.listContactsAdresses, 'priority');
            if (this.contact.listContactsAdresses[0]?.mail) {
              this.contact.mail = this.contact.listContactsAdresses[0].mail;
            }
            this.contactForm.patchValue(this.contact);
            if (this.contact.typeSociete === true) {
              this.text = `Edition de ${this.contact.nom ? this.contact.nom : ''}`;
            } else {
              this.text = `Edition de ${this.contact.nom ? this.contact.nom : ''} ${this.contact.prenom ? this.contact.prenom : ''}`;
            }
          },
        });
      },
      error: (error) => {
        console.error('Error : ', error);
      },
    });
  }

  onTvaCodeChg(codeTva, isInitial?: boolean): void {
    this.codePays = codeTva;
    this.tvaFrMode = false;
    const tvaCountry = this.countriesList.find((p) => p.codePays === codeTva);
    this.paysContactID = tvaCountry.id;
    if (isInitial) {
      this.contactForm.patchValue({ tva: this.contact.tva });
    }

    switch (codeTva) {
      case 'BE':
        this.contact.pasDeTVABelge = false;
        this.tvaMask = `BE-9999999999`;
        this.tvaPlaceholder = 'BE-9999999999';
        this.bcePlaceholder = '9999999999';
        this.bceMask = '9999999999';
        this.bceTooltip = '10 chiffres.';
        break;
      case 'NL':
        this.contact.pasDeTVABelge = true;
        this.tvaMask = `NL-999999999B99`;
        this.tvaPlaceholder = 'NL-999999999B99';
        this.bcePlaceholder = '';
        this.bceMask = '';
        this.bceTooltip = '';
        break;
      case 'LU':
        this.contact.pasDeTVABelge = true;
        this.tvaMask = `LU-99999999`;
        this.tvaPlaceholder = 'LU-99999999';
        this.bcePlaceholder = '';
        this.bceMask = '';
        this.bceTooltip = '';
        break;
      case 'FR':
        this.contact.pasDeTVABelge = true;
        this.tvaFrMode = true;
        if (!isInitial) {
          this.contactForm.patchValue({ tva: null });
        }
        this.bcePlaceholder = '';
        this.bceMask = '';
        this.bceTooltip = '';
        break;
      case 'DE':
        this.contact.pasDeTVABelge = true;
        this.tvaMask = `DE-999999999`;
        this.tvaPlaceholder = 'DE-999999999';
        this.bcePlaceholder = '';
        this.bceMask = '';
        this.bceTooltip = '';

        break;
    }
  }

  hasChanges(args): boolean {
    if (args === true) {
      return true;
    } else {
      return false;
    }
  }

  handleChange(e): void {
    this.activeIndex = e.index;
    if (this.activeIndex !== 0) {
      this.buttons = [
        {
          text: 'Retour',
          styleClass: 'blue',
          disabled: false,
          click: () => {
            this.return();
          },
        },
      ];
    } else {
      this.buttons = [
        {
          text: 'Retour',
          styleClass: 'blue',
          disabled: false,
          click: () => {
            this.return();
          },
        },
        {
          text: 'Enregistrer',
          styleClass: 'blue',
          disabled: false,
          click: () => {
            this.onSubmit();
          },
        },
      ];
    }
  }

  onCountryChange(country: string): void {
    this.prefixNumber = '';
    this.countriesJSON['default'].filter((item) => {
      if (country === item.code) {
        this.prefixNumber = item.value;
      }
    });
  }

  return(): void {
    if (this.isFromModal) {
      this.ref.close();
    } else {
      this.router.navigateByUrl('/private/ic/contacts/details/' + this.contactId);
    }
  }

  receiveEditEnabled(event): void {
    this.editEnabledGuard = event;
  }

  focusAutoComplete(): void {
    if (this.stateDropdown) {
      const random = (Math.random() + 1).toString(36).substring(7);
      this.stateDropdown.renderer.setAttribute(this.stateDropdown['inputEL'].nativeElement, 'autocomplete', random);
    }
  }

  convertImpression(index: number): void {
    const address: StreetsByCountry = this.getAdressPrincipal.at(index).get('structure_RueId').value;
    const cp = this.getAdressPrincipal.at(index).get('structure_LocaliteId').value;
    const pays = this.getAdressPrincipal.at(index).get('pays').value;
    const number: string = this.getAdressPrincipal.at(index).get('structure_RueNumero').value;
    const boite: string = this.getAdressPrincipal.at(index).get('structure_RueBoite').value;

    const gen_address = this.setAddressConfig(address, boite, number);

    this.getAdressPrincipal.at(index).patchValue({
      impression_Adresse: gen_address,
      impression_CodePostal: cp ? cp.codePostal : '',
      impression_Localite: cp?.city ? cp.city : cp?.localite ? cp.localite : '',
      impression_Pays: pays ? this.countriesList.find((x) => x.id === pays).description : '',
    });
  }

  openNewPostalCodeModal(i: number, type: 'structure' | 'impression'): void {
    this.actualIndexOfAddressToBeModified = i;
    this.typeOfAddressToBeModified = type;
    this.countriesService.fetchCountries().subscribe({
      next: (res: CountryDto[]) => {
        this.countries = [];
        if (res?.length > 0) {
          res.map((item) => {
            this.countries.push({ label: item.description, value: item.id });
          });
        }
        this.showCreateCP = true;
      },
      error: (err: HttpErrorResponse) => console.error(err),
    });
  }

  openNewStreetModal(i: number, type: 'structure' | 'impression'): void {
    this.actualIndexOfStreetToBeModified = i;
    this.typeOfStreetToBeModified = type;
    this.showCreateStreet = true;
  }

  openNewTypeContact(): void {
    this.spinner.show();
    forkJoin({
      contactTypes: this.contactsGlobalService.fetchContactTypes().pipe(
        catchError(() => {
          this.toastr.error('Une erreur est survenue lors de la recherche des types de contact');
          this.spinner.hide();
          return of(null);
        })
      ),
      contactsGroups: this.groupsService.fetchGlobalGroups().pipe(
        catchError(() => {
          this.toastr.error('Une erreur est survenue lors de la recherche des groupes de contact');
          this.spinner.hide();
          return of(null);
        })
      ),
      lowInfosIC: this.contactsService.getLowInformationsContactsiCourrier({ includeContactParent: true }).pipe(
        catchError(() => {
          this.toastr.error('Une erreur est survenue lors de la recherche des contacts de iCourrier');
          this.spinner.hide();
          return of(null);
        })
      ),
    }).subscribe((value) => {
      this.formatContactsTypes(value.contactTypes);
      this.formatContactsGroups(value.contactsGroups);
      this.formatLowInformationsContactsiCourrier(value.lowInfosIC, true);
      this.spinner.hide();
      this.showCreateContactType = true;
    });
  }

  private formatContactsTypes(contactTypes: ContactTypeDto[]): void {
    this.typesLV = [];
    if (contactTypes?.length) {
      contactTypes.forEach((item) => {
        this.typesLV.push({ label: item.typeContact, value: item.id });
      });
    }
  }

  private formatContactsGroups(contactGroups: GroupsGlobalDto[]): void {
    this.groups = [];
    if (contactGroups.length) {
      contactGroups.forEach((item) => {
        this.groups.push({ label: item.description, value: item.id });
      });
    }
  }

  filterContact(event): void {
    if (event?.value !== null) {
      this.contacts = this.contactsInit.filter((x) => x.typeContactID === event.value);
    } else {
      this.contacts = this.contactsInit;
    }
  }

  submitNewCP(): void {
    if (this.formCP.valid) {
      const params = new PostPostalCodeParams(this.formCP.value);
      this.contactsService.postPostalCode(params).subscribe({
        next: (res: ManagementPostalCodesDTO) => {
          if (this.typeOfAddressToBeModified === 'structure') {
            // on va déjà vérifier s'il y a un pays dans le formulaire et que celui-ci soit égal au pays de l'adresse créée.
            const country = this.countriesList.find((x) => x.id === this.getAdressPrincipal.at(this.actualIndexOfAddressToBeModified).value.pays);
            if (country?.id && this.getAdressPrincipal.at(this.actualIndexOfAddressToBeModified).value.pays === this.formCP.value.paysID) {
              this.getPostalCodes(country).then(() => {
                let locToPatch;
                if (this.postalCodesList.find((x) => x.id === res.id)?.id) {
                  //si on a bien une localité
                  locToPatch = this.postalCodesList.find((x) => x.id === res.id);
                  locToPatch.autoCompleteField =
                    (locToPatch.codePostal ? locToPatch.codePostal : '') + ': ' + (locToPatch.localite ? locToPatch.localite : '');
                }
                // Si on a une localité a patcher, il faut vider la rue!
                this.getAdressPrincipal.at(this.actualIndexOfAddressToBeModified).patchValue({
                  structure_LocaliteId: this.postalCodesList.find((x) => x.id === res.id)?.id
                    ? locToPatch
                    : this.getAdressPrincipal.at(this.actualIndexOfAddressToBeModified).value.structure_LocaliteId,
                  structure_RueId: locToPatch ? null : this.getAdressPrincipal.at(this.actualIndexOfAddressToBeModified).value.structure_RueId,
                });

                //Une fois le patch effectué, on va aller essayer de récupérer toutes les rues
                //déjà on va le faire ssi il existe un pays && une loc dans le formulaire
                if (this.getAdressPrincipal.at(this.actualIndexOfAddressToBeModified).value.structure_LocaliteId?.id) {
                  const data = {
                    id: this.getAdressPrincipal.at(this.actualIndexOfAddressToBeModified).value.structure_LocaliteId.id,
                    pays: country,
                  };
                  this.getStreetsFromiCourrier(data);
                  this.toastr.success('Le code postal a bien été enregistré');
                  this.formCP.reset();
                  this.showCreateCP = false;
                } else {
                  this.toastr.success('Le code postal a bien été enregistré');
                  this.formCP.reset();
                  this.showCreateCP = false;
                }
              });
            }
          } else {
            this.getAdressPrincipal.at(this.actualIndexOfAddressToBeModified).patchValue({
              impression_CodePostal: res.codePostal,
              impression_Localite: res.localite,
              impression_Adresse: '',
            });
            this.toastr.success('Le code postal a bien été enregistré');
            this.formCP.reset();
            this.showCreateCP = false;
          }
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la création du code postal');
        },
      });
    } else {
      this.toastr.warning("Vous n'avez pas rempli tous les champs obligatoires");
    }
  }

  submitNewStreet(): void {
    if (this.formStreet.valid) {
      const params = new ManagementStreetsParams(this.formStreet.value);
      this.contactsService.postStreet(params).subscribe({
        next: (res: ManagementStreetsDTO) => {
          if (this.typeOfStreetToBeModified === 'structure') {
            // On va déjà vérifier s'il y a un cp et si celui ci correspond au cp de la rue créée
            const zip = this.getAdressPrincipal.at(this.actualIndexOfStreetToBeModified).value.structure_LocaliteId?.codePostal;
            const country = this.countriesList.find((x) => x.id === this.getAdressPrincipal.at(this.actualIndexOfStreetToBeModified).value.pays);
            if (zip && zip === this.formStreet.value.codePostal) {
              const data = {
                id: this.getAdressPrincipal.at(this.actualIndexOfStreetToBeModified).value.structure_LocaliteId.id,
                pays: country,
              };
              this.getStreetsFromiCourrier(data).then(() => {
                this.getAdressPrincipal.at(this.actualIndexOfStreetToBeModified).patchValue({
                  structure_RueId: this.streetsList.find((x) => x.id === res.id)?.id
                    ? this.streetsList.find((x) => x.id === res.id)
                    : this.getAdressPrincipal.at(this.actualIndexOfStreetToBeModified).value.structure_RueId,
                });
                this.toastr.success('La rue a bien été enregistrée');
                this.formStreet.reset();
                this.showCreateStreet = false;
              });
            }
          } else {
            this.getAdressPrincipal.at(this.actualIndexOfStreetToBeModified).patchValue({
              impression_Adresse: res.rue,
            });
            this.toastr.success('La rue a bien été enregistrée');
            this.formStreet.reset();
            this.showCreateStreet = false;
          }
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la création de la rue');
        },
      });
    } else {
      this.toastr.warning("Vous n'avez pas rempli tous les champs obligatoires");
    }
  }

  submitNewContactType(): void {
    if (this.formContactType.value.categorie === null) {
      this.formContactType.value.categorie = false;
    }
    if (this.formContactType.value.nePasInclureArbreDestinataires === null) {
      this.formContactType.value.nePasInclureArbreDestinataires = false;
    }
    if (this.formContactType.value.nePasRemplirLaListe === null) {
      this.formContactType.value.nePasRemplirLaListe = false;
    }
    if (this.formContactType.value.sanctionTypeVictime === null) {
      this.formContactType.value.sanctionTypeVictime = false;
    }
    if (this.formContactType.value.verrouille === null) {
      this.formContactType.value.verrouille = false;
    }
    if (this.formContactType.valid) {
      const params = new ContactTypeParams(this.formContactType.value);
      this.contactsService.postManagementContactType(params).subscribe({
        next: (res: ContactTypeDto) => {
          this.toastr.success('Le type a bien été enregistré');
          this.showCreateContactType = false;
          //on va récupérer tous les types de contacts puis patcher

          this.contactsGlobalService.fetchMappedContactTypesToPrimeNGDropdowns().subscribe({
            next: (response) => {
              this.typeContacts = response;
              this.typeContacts.map((item) => {
                item.label = item.label.charAt(0).toUpperCase() + String(item.label).slice(1).toLowerCase();
              });
              this.contactForm.patchValue({ typeContactId: res.id });
            },
            error: (err: HttpErrorResponse) => {
              console.error(err);
            },
          });
        },
      });
    } else {
      this.toastr.warning("Vous n'avez pas rempli tous les champs obligatoires");
    }
  }

  public leaveInput(type, index): void {
    window.setTimeout(() => {
      if (type === 'cp') {
        const cp = this.contactForm.value.listContactsAdresses.at(index).structure_LocaliteId;
        if (
          typeof cp == 'string' &&
          cp !== '' &&
          (this.contactForm.value.listContactsAdresses.at(index).structure_LocaliteId?.id <= 0 ||
            !this.contactForm.value.listContactsAdresses.at(index).structure_LocaliteId?.id)
        ) {
          this.toastr.warning("Le code postal-localité n'est pas valide. Veuillez en choisir un existant sinon il ne sera pas enregistré");
        }
      } else if (type === 'street') {
        const street = this.contactForm.value.listContactsAdresses.at(index).structure_RueId;
        if (
          typeof street == 'string' &&
          street !== '' &&
          (this.contactForm.value.listContactsAdresses.at(index).structure_RueId?.id <= 0 ||
            !this.contactForm.value.listContactsAdresses.at(index).structure_RueId?.id)
        ) {
          this.toastr.warning("La rue n'est pas valide. Veuillez en choisir une existante sinon elle ne sera pas enregistrée");
        }
      }
    }, 500);
  }

  public clearStreet(index: number): void {
    this.getAdressPrincipal.at(index).patchValue({ structure_RueId: null });
  }

  public clearZIPAndStreet(index: number): void {
    this.getAdressPrincipal.at(index).patchValue({ structure_LocaliteId: null, structure_RueId: null });
  }

  public onSelectSector(event): void {
    this.contactForm.value.secteurActivite = event.value;
  }
}
